/**
 * Bỏ prefix "Giải " ở đầu tên giải (vd: "Giải Ngoại hạng Anh" → "Ngoại hạng Anh").
 * @param {string} name
 * @returns {string}
 */
export default function stripLeadingGiai(name) {
  if (name == null) return "";
  return String(name).replace(/^Giải\s+/i, "").trim();
}
